import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const DonationsPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <section className="py-12 bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-emerald-700 hover:text-emerald-800 mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <div className="flex items-start space-x-4">
            <div className="w-16 h-16 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Heart className="w-8 h-8 text-emerald-600" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Donations Policy</h1>
              <p className="text-gray-600">Delinam Foundation</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <Card className="border-2 border-gray-200 shadow-lg">
              <CardContent className="p-6 sm:p-8 lg:p-12">
                <div className="prose prose-gray max-w-none">
                  {/* Last Updated */}
                  <p className="text-sm text-gray-500 mb-8">
                    Last updated: February 17, 2026
                  </p>

                  {/* Introduction */}
                  <p className="text-gray-700 leading-relaxed mb-8">
                    Delinam Foundation gratefully accepts donations to support our mission of empowering 
                    individuals and strengthening communities through sustainable development, youth 
                    empowerment, and local leadership initiatives.
                  </p>

                  {/* Use of Donations */}
                  <div className="mb-8">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-emerald-600">
                      Use of Donations
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      All donations are used to support Delinam Foundation's programs, operations, and 
                      mission-related activities. While we make every effort to apply funds to the areas 
                      of greatest need, the specific allocation of donations is determined by organizational 
                      priorities.
                    </p>
                  </div>

                  {/* Refunds */}
                  <div className="mb-8">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-emerald-600">
                      Refunds
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      Donations are voluntary and generally non-refundable. Refund requests may be 
                      considered only in cases of verified technical error or duplicate transactions 
                      and must be submitted within 7 days of the donation date.
                    </p>
                  </div>

                  {/* Payment Processing */}
                  <div className="mb-8">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-emerald-600">
                      Payment Processing
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      Donations may be processed through third-party payment providers (e.g., Stripe, PayPal). 
                      Delinam Foundation does not store your full payment information and is not responsible 
                      for errors or interruptions caused by third-party platforms.
                    </p>
                  </div>

                  {/* Receipts and Tax Information */}
                  <div className="mb-8">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-emerald-600">
                      Receipts and Tax Information
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      Delinam Foundation is not currently a registered charity and cannot issue Canadian official charitable donation tax receipts.  
                       
                      Donors are encouraged to consult a tax professional about their individual circumstances.
                    </p>
                  </div>

                  {/* Fraud Prevention */}
                  <div className="mb-8">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-emerald-600">
                      Fraud Prevention
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      Delinam Foundation reserves the right to refuse or return any donation that appears 
                      fraudulent, unlawful, or inconsistent with our values and compliance obligations.
                    </p>
                  </div>

                  {/* Contact */}
                  <div className="bg-emerald-50 border-l-4 border-emerald-600 p-6 rounded-r-lg">
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 flex items-center">
                      <Mail className="w-6 h-6 mr-2 text-emerald-600" />
                      Contact
                    </h2>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Questions regarding donations may be sent to:
                    </p>
                    <a 
                      href="mailto:info@delinamfoundation.org"
                      className="text-emerald-700 hover:text-emerald-800 font-medium"
                    >
                      info@delinamfoundation.org
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DonationsPolicy;
